/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DuplicateOrganizationRemoteSessionClientForm,
  DuplicateOrganizationRemoteSessionClientForm$Outbound,
  DuplicateOrganizationRemoteSessionClientForm$outboundSchema,
} from "../components/duplicateorganizationremotesessionclientform.js";

export type DuplicateOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type DuplicateOrganizationRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  duplicateOrganizationRemoteSessionClientForm:
    DuplicateOrganizationRemoteSessionClientForm;
};

/** @internal */
export type DuplicateOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const DuplicateOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    DuplicateOrganizationRemoteSessionClientSecurity$Outbound,
    DuplicateOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function duplicateOrganizationRemoteSessionClientSecurityToJSON(
  duplicateOrganizationRemoteSessionClientSecurity:
    DuplicateOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    DuplicateOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      duplicateOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type DuplicateOrganizationRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  DuplicateOrganizationRemoteSessionClientForm:
    DuplicateOrganizationRemoteSessionClientForm$Outbound;
};

/** @internal */
export const DuplicateOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    DuplicateOrganizationRemoteSessionClientRequest$Outbound,
    DuplicateOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      duplicateOrganizationRemoteSessionClientForm:
        DuplicateOrganizationRemoteSessionClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        duplicateOrganizationRemoteSessionClientForm:
          "DuplicateOrganizationRemoteSessionClientForm",
      });
    }),
  );

export function duplicateOrganizationRemoteSessionClientRequestToJSON(
  duplicateOrganizationRemoteSessionClientRequest:
    DuplicateOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    DuplicateOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      duplicateOrganizationRemoteSessionClientRequest,
    ),
  );
}
